import { useState } from 'react';
import { Link } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import { api, errMsg } from '../../lib/api';

export default function AdminLogin({ onSuccess }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api.post('/admin/login', { password });
      onSuccess();
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#02040a] nebula-mesh flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-white/[0.08] bg-[#060a14]/80 backdrop-blur-xl p-10">
        <div className="flex items-center gap-2.5 mb-8">
          <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse-dot" />
          <span className="font-celestial text-xs tracking-[0.25em] text-slate-200">DOCTRINE VAULT</span>
        </div>
        <h1 className="font-celestial text-2xl text-slate-100">Enter the passphrase</h1>
        <p className="text-sm text-slate-500 mt-2">Restricted to the studio. One key, one node.</p>
        <label className="block mt-8 font-mono-precision text-[10px] uppercase tracking-[0.25em] text-slate-500">Passphrase</label>
        <div className="mt-2 flex items-center gap-3 rounded-xl border border-white/10 bg-black/40 px-4 focus-within:border-amber-400/60 transition-colors">
          <KeyRound size={15} className="text-slate-500" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="flex-1 bg-transparent py-3 text-sm text-slate-100 outline-none" autoFocus data-testid="admin-password-input" />
        </div>
        {error && <p className="mt-3 text-xs text-rose-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy || !password} className="mt-6 w-full rounded-full bg-amber-400 hover:bg-amber-300 disabled:opacity-40 text-[#02040a] font-mono-precision text-[11px] uppercase tracking-[0.25em] py-3 transition-colors" data-testid="admin-login-submit">
          {busy ? 'Verifying…' : 'Unlock vault'}
        </button>
        <Link to="/" className="block mt-6 text-center font-mono-precision text-[10px] uppercase tracking-[0.2em] text-slate-600 hover:text-slate-400">← Return to site</Link>
      </form>
    </div>
  );
}
